import http from 'axios'

export default {
  getAssolement: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/assolement`)
  }
}
